import styled from 'styled-components'

import NumberField from '@/ui/NumberField'
import Form from '@/ui/Form'

export const StyledInput = styled(NumberField)`
  &&&& {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;

    &:focus {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`

export const StyledSelect = styled(Form.Select)`
  &&& {
    .ui.selection.dropdown {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: none !important;
      background-color: #f7f8fa;
    }
  }
`
